module.exports = __webpack_public_path__ + "img/logo.b55692f7.svg";